import getByKey from './getByKey';

// base on EURO
const RATES = {
    EUR: 1,
    CAD: 1.5359,
    HKD: 8.4391,
    ISK: 156.5,
    PHP: 55.414,
    DKK: 7.4619,
    HUF: 349.56,
    CZK: 27.053,
    AUD: 1.7266,
    RON: 4.8373,
    SEK: 10.8895,
    IDR: 17089.8,
    INR: 83.705,
    BRL: 5.699,
    RUB: 80.621,
    HRK: 7.601,
    JPY: 117.12,
    THB: 35.56,
    CHF: 1.0516,
    SGD: 1.5539,
    PLN: 4.5288,
    BGN: 1.9558,
    TRY: 7.5506,
    CNY: 7.6991,
    NOK: 11.4145,
    NZD: 1.821,
    ZAR: 20.2373,
    USD: 1.0888,
    MXN: 26.2939,
    ILS: 3.9082,
    GBP: 0.87163,
    KRW: 1334.51,
    MYR: 4.7655,
} as const;

export default function getEurToCurrencyRate(
    currency: string
): number | undefined {
    const upperCurrency = currency.toLocaleUpperCase();

    return getByKey(RATES, upperCurrency);
}
